import { useEffect } from 'react'

import { Box, Text, Tooltip, useToggle } from '@factorialco/deprecated-design-system'

import { track, trackingEvents } from 'modules/core/lib/Tracking'

type TooltipTrackingGroup =
  | 'engagement-signal'
  | 'nine-box-grid'
  | 'performance-score'
  | 'potential-score'
  | 'pulse-survey'

interface Prop {
  children: React.ReactNode
  label?: string | null
  whiteSpace?: 'normal' | 'breakSpaces'
  trackingGroup?: TooltipTrackingGroup
}

const WithToolTip = ({ children, label, trackingGroup, whiteSpace }: Prop) => {
  const [isOpen, onToggle] = useToggle()

  useEffect(() => {
    if (isOpen && trackingGroup) {
      track(trackingEvents.performanceAnalytics.insightsSummaryTooltipViewed, {
        name: trackingGroup,
      })
    }
  }, [isOpen, trackingGroup])

  if (!label) return <>{children}</>

  return (
    <Box width="fit-content">
      <Tooltip.Alt
        toggle={onToggle}
        open={isOpen}
        attachment="bottom center"
        label={
          <Text.Normal size="100" whiteSpace={whiteSpace}>
            {label}
          </Text.Normal>
        }
      >
        {children}
      </Tooltip.Alt>
    </Box>
  )
}

export default WithToolTip
